import { ACTION } from "@common/constants/redux";

export const setVoucherFilter = (filter) => {
  return (dispatch) => {
    dispatch({
      type: ACTION.SET_VOUCHER_FILTER,
      payload: filter,
    });
  };
};
